import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import CataloguePage from "./pages/CataloguePage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import AuthPage from "./pages/AuthPage";
import AccountPage from "./pages/AccountPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import GripKitPage from "./pages/GripKitPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import AccountDeletedPage from "./pages/AccountDeletedPage";
import ProductBySlug from "./pages/ProductBySlug";
import LocationCameraCinemaParis from "./pages/guides/LocationCameraCinemaParis";
import SonyFx3VsFx6 from "./pages/guides/SonyFx3VsFx6";
import SitePopup from "./components/SitePopup";
import CartMergeModal from "./components/CartMergeModal";
import ScrollToTop from "./components/ScrollToTop";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/catalogue" element={<CataloguePage />} />
                <Route path="/produit/:id" element={<ProductDetailPage />} />
                <Route path="/panier" element={<CartPage />} />
                <Route path="/connexion" element={<AuthPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/compte" element={<AccountPage />} />
                <Route path="/mon-compte" element={<AccountPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/kit-grip" element={<GripKitPage />} />
                <Route path="/desinscription" element={<UnsubscribePage />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/compte-supprime" element={<AccountDeletedPage />} />
                <Route path="/guides/location-camera-cinema-paris" element={<LocationCameraCinemaParis />} />
                <Route path="/guides/sony-fx3-vs-fx6" element={<SonyFx3VsFx6 />} />
                {/* SEO product URL /location-{slug}-{id} — must stay LAST because it uses a bare dynamic segment */}
                <Route path="/:productSlug" element={<ProductBySlug />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster />
          <SitePopup />
          <CartMergeModal />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
